import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="py-10 px-6 border-t border-border bg-background" data-testid="site-footer">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2 mb-3">
            <BrandLogo size={22} />
            <span className="font-bold text-base">PassADC</span>
          </Link>
          <p className="text-xs text-muted-foreground">
            The smartest way to prepare for the Australian Dental Council exam.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Product</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/diagnostic" className="text-muted-foreground hover:text-foreground transition-colors">Free diagnostic</Link></li>
            <li><Link to="/adc-part-1" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-adc-part-1">ADC Part 1 hub</Link></li>
            <li><Link to="/guides" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-guides">Exam guides</Link></li>
            <li><Link to="/signup" className="text-muted-foreground hover:text-foreground transition-colors">Create account</Link></li>
            <li><Link to="/login" className="text-muted-foreground hover:text-foreground transition-colors">Sign in</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/refund" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-refund">Refund Policy</Link></li>
            <li><Link to="/guarantee" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-guarantee">80% Readiness Commitment</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Contact</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-contact">Contact us</Link></li>
            <li><a href="mailto:hello@passadc.com" className="text-muted-foreground hover:text-foreground transition-colors">hello@passadc.com</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-6xl mx-auto pt-6 border-t border-border/60 flex flex-col md:flex-row justify-between items-center gap-2">
        <p className="text-xs text-muted-foreground">© {year} PassADC. All rights reserved.</p>
        <p className="text-xs text-muted-foreground">Made for international dentists.</p>
      </div>
    </footer>
  );
};

export default Footer;
